import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import { ToolModel } from "@/store/models/tools/Tool";
import { toaster } from "../../../utilities/toaster";
import ToolModule from "@/store/modules/tool.module";
let ToolAdd = /** @class */ (() => {
    let ToolAdd = class ToolAdd extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Tool";
            this.ctaButtons = [
                {
                    routeName: "Tools",
                },
            ];
            this.items = [
                {
                    text: "Tools",
                },
                {
                    text: "Add Tool",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.selectedTool = new ToolModel();
        }
        saveTool() {
            this.validate("newUserObserver").then((response) => {
                if (response) {
                    ToolModule.SaveTool(this.selectedTool).then((response) => {
                        toaster.ShowSuccess("Tool was created successfully.");
                        ToolModule.GetTools().then((response) => { });
                        this.$router.push({ name: "Tools" });
                    });
                }
            });
        }
        cancelTool() {
            this.selectedTool = new ToolModel();
            this.selectedTool = Object.assign({}, this.selectedTool);
            this.selectedTool = {
                id: this.selectedTool.id,
                name: this.selectedTool.name,
                latestVersion: this.selectedTool.latestVersion,
                discription: this.selectedTool.discription,
                price: this.selectedTool.price,
                url: this.selectedTool.url,
                userLimits: this.selectedTool.userLimits,
            };
            this.$router.push({ name: "Tools" });
        }
        // LIFECYCLE
        created() {
            this.pageIsLoading = false;
        }
    };
    ToolAdd = __decorate([
        Component({
            name: "ToolAdd",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], ToolAdd);
    return ToolAdd;
})();
export default ToolAdd;
